import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InputAtomSharedComponent } from './input.component';

@NgModule({
    declarations: [
        InputAtomSharedComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        InputAtomSharedComponent
    ]
})

export class InputAtomSharedModule {}
